import type {FC} from 'react'
import {Blankslate as PrimerBlankslate} from '@primer/react/experimental'
import styles from './Blankslate.module.css'

type BlankslateProps = {
  heading: string
  headingAs?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  children?: React.ReactNode
}

export const Blankslate: FC<BlankslateProps> = ({heading, headingAs = 'h3', children}) => {
  return (
    <div className={styles.BlankslateContainer}>
      <PrimerBlankslate>
        <PrimerBlankslate.Heading as={headingAs}>{heading}</PrimerBlankslate.Heading>
        {children ? <PrimerBlankslate.Description>{children}</PrimerBlankslate.Description> : null}
      </PrimerBlankslate>
    </div>
  )
}
